"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tokens_1 = __importDefault(require("@paprika/tokens"));
var LaunchpadLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/LaunchpadLogo"));
var Academy_1 = __importDefault(require("@acl-services/wasabicons/lib/Academy"));
var CommunityLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/CommunityLogo"));
var ToolsAndTemplatesLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/ToolsAndTemplatesLogo"));
var HelpdocsLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/HelpdocsLogo"));
var LifeBuoy_1 = __importDefault(require("@acl-services/wasabicons/lib/LifeBuoy"));
var Download_1 = __importDefault(require("@acl-services/wasabicons/lib/Download"));
var Design_1 = __importDefault(require("@acl-services/wasabicons/lib/Design"));
var resourceData = [
    {
        icon: LaunchpadLogo_1.default,
        iconColor: tokens_1.default.color.blackLighten10,
        key: 'launchpad',
    },
    {
        icon: Academy_1.default,
        iconColor: tokens_1.default.color.blackLighten10,
        key: 'academy',
    },
    {
        icon: CommunityLogo_1.default,
        iconColor: tokens_1.default.color.blackLighten10,
        key: 'community',
    },
    {
        icon: Design_1.default,
        iconColor: tokens_1.default.color.blackLighten10,
        key: 'toolkits',
    },
    {
        icon: ToolsAndTemplatesLogo_1.default,
        iconColor: tokens_1.default.color.blackLighten10,
        key: 'tools_and_templates',
    },
    {
        icon: HelpdocsLogo_1.default,
        iconColor: tokens_1.default.color.blackLighten10,
        key: 'help_docs',
    },
    {
        icon: LifeBuoy_1.default,
        iconColor: tokens_1.default.color.blackLighten10,
        key: 'support',
    },
    {
        icon: Download_1.default,
        iconColor: tokens_1.default.color.blackLighten10,
        key: 'downloads',
    },
];
exports.default = resourceData;
//# sourceMappingURL=resourceData.js.map